import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import styled from "@emotion/styled";
import { fetchArticleById } from "../services/articleService";
import LeftArrow from "../assets/left-arrow.svg";

const ArticleContainer = styled.div`
  padding: 40px;
  color: black;
  background-color: #faf7f3;
  min-height: 80vh;
  overflow: hidden;
  @media (max-width: 768px) {
   padding-top:20px!important;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 20px;
  text-transform: uppercase;
  font-family: "Courier New", monospace;
  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Content = styled.section`
  flex: 5;
  font-size: 16px;
  line-height: 1.6;
  border-top: 1px solid black;
  margin-right: 40px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Author = styled.p`
  font-size: 14px;
  color: #718096;
  text-align: center;
  font-style: italic;
`;

const Image = styled.section`
  flex: 2;
  height: auto;
  object-fit: cover;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const RelatedSection = styled.section`
  flex: 1;
  h2 {
    font-size: 18px;
    font-weight: 600;
    color: #a3b4e2;
    margin-bottom: 16px;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      padding: 8px 0;
      margin-bottom: 12px;
      border-bottom: 1px solid #a3b4e2;
      a {
        font-size: 16px;
        color: #a3b4e2; /* Tailwind's blue-600 */
        text-decoration: none;

        &:hover {
          color: #a3b4e2; /* Tailwind's blue-800 */
        }
      }
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Flex = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px !important;
  }
`;

const BackButton = styled.div`
  cursor: pointer;
`;

const RelatedTitle = styled.div`
  font-weight: 500;
  font-size: 18px;
  color: #a3b4e2;
`;

const ArticleView = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadArticle = async () => {
      try {
        const art = await fetchArticleById(id);
        setArticle(art.data);
      } catch (err) {
        console.error(err);
      }
    };
    loadArticle();
  }, [id]);

  const handleReadClick = () => {
    navigate(`/article/${article.id}`);
  };

  return (
    <ArticleContainer>
      <Flex>
        <BackButton onClick={() => navigate("/")}>
          <img src={LeftArrow} alt="Back" width="auto" height="60px" />
        </BackButton>
        <Title>{article?.name}</Title>
      </Flex>

      {article && (
        <Flex>
          <Content>
            <Author>
              by {article.author} <br />
              Graham Thorburn
            </Author>
            <div dangerouslySetInnerHTML={{ __html: article.content }} />
          </Content>
          {article.image && <Image>
            {" "}
            <img src={article.image} alt={article.title} width="100%" />
          </Image>}

          <RelatedSection>
            <RelatedTitle>RELATED</RelatedTitle>
            <ul>
              {article.related_articles.map((element) => (
                <li key={element.id}>
                  <Link class="text-uppercase" to={`/article/${element.id}`} onClick={handleReadClick}>{element.name}</Link>
                </li>
              ))}
            </ul>
          </RelatedSection>
        </Flex>
      )}
    </ArticleContainer>
  );
};

export default ArticleView;
